// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"475b5e94","61":"c25569d1","121":"7591d19a","301":"c25569d1","588":"c25569d1","754":"4c090288"}[chunkId] + ".chunk.css";
};